module.exports = __webpack_public_path__ + "img/electronic_reserved_selected.48051b70.svg";